module.exports = __webpack_public_path__ + "img/img5.699e3ac1.png";